import { INTRODUCTION, ELEMENTARY_AND_MIDDLE_SCHOOL_ELA, ENGLISH_LEARNERS, HIGH_SCHOOL_ELA, SOCIAL_STUDIES, } from './constants'
import introductionSlides from './introduction_slides'
import elementaryAndMiddleSchoolELASlides from './elementary_and_middle_school_ela_slides'
import englishLearnersSlides from './english_learners_slides'
import highSchoolELASlides from './high_school_ela_slides'
import socialStudiesSlides from './social_studies_slides'

const tourToSlides = {
  [INTRODUCTION]: introductionSlides,
  [ELEMENTARY_AND_MIDDLE_SCHOOL_ELA]: elementaryAndMiddleSchoolELASlides,
  [ENGLISH_LEARNERS]: englishLearnersSlides,
  [HIGH_SCHOOL_ELA]: highSchoolELASlides,
  [SOCIAL_STUDIES]: socialStudiesSlides,
}

export default tourToSlides
